import { render } from "./Form.vue?vue&type=template&id=f65738f6&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=f65738f6&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65738f6"]])

export default __exports__